import {Segmented, DatePicker} from "antd";
import dayjs from "dayjs";

/**
 * Bộ lọc kỳ cho Dashboard CEO: Tháng / Quý / Năm + chọn mốc thời gian.
 * Quý được suy ra ở backend từ tháng của mốc, nên chỉ cần month/year picker.
 *
 * Props:
 *  - period: 'month' | 'quarter' | 'year'
 *  - time:   unix seconds (mốc thời gian)
 *  - onChange({ period, time })
 */
const PERIOD_OPTIONS = [
	{label: 'Tháng', value: 'month'},
	{label: 'Quý', value: 'quarter'},
	{label: 'Năm', value: 'year'},
];

function DashboardPeriodFilter({period = 'month', time, onChange}) {

	const value  = time ? dayjs.unix(time) : dayjs();
	const picker = period === 'year' ? 'year' : 'month';
	const unit   = period === 'year' ? 'year' : 'month';
	const format = period === 'year' ? 'YYYY' : 'MM/YYYY';

	const handlePeriod = (val) => {
		onChange?.({period: val, time: value.startOf(val === 'year' ? 'year' : 'month').unix()});
	};

	const handleDate = (d) => {
		if (d) onChange?.({period, time: d.startOf(unit).unix()});
	};

	return (
		<div style={{display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap'}}>
			<Segmented options={PERIOD_OPTIONS} value={period} onChange={handlePeriod} />
			<DatePicker
				picker={picker}
				allowClear={false}
				value={value}
				format={format}
				onChange={handleDate}
				style={{width: 140}}
			/>
		</div>
	);
}

export default DashboardPeriodFilter;
